import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isNumber } from 'lodash';

function round(n: number, decimalPlaces: number = 2) {
  let precision = Math.pow(10, decimalPlaces);
  return Math.round(n * precision) / precision;
}

@Component({
  selector: 't-percent',
  templateUrl: './percent.component.html',
  host: {
    class: 'percent'
  }
})
export class PercentComponent implements OnChanges {
  
  @Input() total: any
  @Input() value: any
  @Input() showValue = true
  @Input() size = 32
  @Input() radius = 10

  percent: number = null;

  // See https://codepen.io/xgad/post/svg-radial-progress-meters
  // stroke-dasharray = 2 * PI * r = 2 * 3.14 * 10 = 62.8
  // stroke-dashoffset = dasharray * (1 - percent) = 62.8 * (1 - 0.6) = 25.12
  dasharray: number
  dashoffset: number = 0
  
  ngOnChanges(changes: SimpleChanges): void {
    this.dasharray = round(Math.PI * 2 * this.radius);
    const total = parseInt(this.total, 10);
    const value = parseInt(this.value, 10);
    
    if(isNumber(total) && isNumber(value)) {
      const ratio = value / total;
      this.percent = round(ratio * 100);
      
      // Prevent strange behaviour if the ratio is more than 100%
      if(ratio >= 1) {
        this.dashoffset = 0;
      }
      else {
        this.dashoffset = round(this.dasharray * (1 - ratio));
      }
    }
    else {
      this.percent = null;
    }
  }
}
